<template>
  <div class="all-box">
    <userInfoPanel :hasAction="hasAction"></userInfoPanel>

    <div style="margin-top: 10px;">
      <van-cell @click="updatePassword" :clickable="clickable" title-class="vanCell" value-class="vanValue" :center="isCenter" title="修改密码" is-link value=" " />
      <van-cell @click="updatePhoneNumber" :clickable="clickable" title-class="vanCell" value-class="vanValue" :center="isCenter" title="修改手机" is-link />
    </div>

    <!--退出登录-->
    <div style="padding: 20px 4%">
      <van-button color="#D6BE93" @click="BTAction_Logout" style="border-radius: 5px;font-size: 1.7em;" type="primary" size="large">退出登录</van-button>
    </div>

  </div>
</template>



<script>
import userInfoPanel from "@/components/userInfoPanel";
import { Dialog } from "vant";

export default {
  name: "userSettingPage",
  components: {
    userInfoPanel
  },
  data() {
    return {
      userPhone: "",
      hasAction: false, //userinfopannel 是否显示右侧箭头
      isCenter: true,
      clickable: false //是否开启点击反馈 https://youzan.github.io/vant/#/zh-CN/cell
    };
  },
  methods: {
    updatePassword() {
      this.$router.push("/updatePassword");
    },
    updatePhoneNumber() {
      this.$router.push("/updatePhone");
    },
    //退出登录
    BTAction_Logout() {
      Dialog.confirm({
        title: "标题",
        message: "您要退出登录么？"
      })
        .then(() => {
          // on confirm
          sessionStorage.clear();
          localStorage.clear();
          this.$store.commit("SET_USERINFO", null);

          sessionStorage.setItem("selectIdx", 1);

          this.$router.push("/");
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  mounted() {
    console.log(this.$store.state.base.userInfo);
    if (this.$store.state.base.userInfo) {
      this.userPhone = this.$store.state.base.userInfo.userInfo.nickName;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.all-box {
  height: 100%;
  width: 100%;
  /*控制底部滚动*/
  overflow: hidden;
  background: #f4f4f4;
}

.vanValue {
  font-size: 1.4em;
}
.vanCell {
  text-align: left;
  height: 2em;
  line-height: 2em;
  font-size: 1.4em;
}
/deep/ .van-button__text {
  font-size: 1.6rem;
}
</style>



// WEBPACK FOOTER //
// src/view/person/userSettingPage.vue